
            window.versions = {
                script: 38,
                atlas: {
                    preloader: 1,
                    core: 2,
                    "core-ui": 2,
                    lobby: 2,
                    competition: 3,
                    popup: 1,
                    promotion: 1,
                    "popup-shop": 2,
                },
                layout: 11,
                sound: 2,
                font: 1,
                ambience: 1,
                descriptor: 10,
                image: 3
            };

            import(/* @vite-ignore */__ENTRY_FILE__);
        